import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from "@angular/flex-layout";
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpModule } from '@angular/http';
import { AppRoutingModule } from './/app-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppComponent } from './app.component';
import { WorseningService } from './services/worsening/worsening.service';
import { WorseningComponent } from './components/worsening/worsening/worsening.component';
//import { MainContentComponent } from './components/general/main-content/main-content.component';
import { RouterModule } from '@angular/router/src/router_module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
  FooterV2Module, HeaderV2Module, ButtonV2Module, CheckboxV2Module, SectionTitleV2Module, TooltipV2Module,
  MohPackageModule, MainContentModule, /*DropdownModule,*/ TextboxV2Module, TelephoneV2Module, LabelFieldModule,
  AddressV2Module, BreadcrumbsModule, DividerModule, FileUploaderV2Module, FormTitleV2Module,
  InfoV2Module, MohBaseElementModule, SlideToggleV2Module, BannerV2Module, TextareaV2Module, SubmitButtonV2Module,
  ErrorMessageV2Module, SelectV2Module, SpinnerModule, RecaptchaModule, FormCardV2Module, 
} from 'moh-package'
import { MohHttpInterceptorService } from './services/general/moh-http-interceptor.service';
import { WorseningClaimerComponent } from './components/worsening/worsening-claimer/worsening-claimer.component';
import { WorseningAdvocateComponent } from './components/worsening/worsening-advocate/worsening-advocate.component';
import { WorseningWorseDetailsComponent } from './components/worsening/worsening-worse-details/worsening-worse-details.component';
import { environment } from '../environments/environment';
import { UtilitiesService } from './services/general/utilities.service';
import { SurvivorsComponent } from './components/survivors/survivors/survivors.component';
import { SurvivorsWizardComponent } from './components/survivors/survivors-wizard/survivors-wizard.component';
import { SurvivorsGuidanceComponent } from './components/survivors/survivors-guidance/survivors-guidance.component';
import { SurvivorsClaimerComponent } from './components/survivors/survivors-claimer/survivors-claimer.component';
import { GzzRepresenterComponent } from './components/general/gzz-representer/gzz-representer.component';
import { SurvivorsClaimComponent } from './components/survivors/survivors-claim/survivors-claim.component';
import { GzzBankAccountDetailsComponent } from './components/general/gzz-bank-account-details/gzz-bank-account-details.component';
import { SurvivorsAdditionalInfoComponent } from './components/survivors/survivors-additional-info/survivors-additional-info.component';
import { GzzFamilyMemberComponent } from './components/general/gzz-family-member/gzz-family-member.component';
import { SurvivorsDeclarationComponent } from './components/survivors/survivors-declaration/survivors-declaration.component';
import { ClaimComponent } from './components/claim/claim/claim.component';
import { GzzMainContentComponent } from './components/general/gzz-main-content/gzz-main-content.component';
import { ClmDeclarationComponent } from './components/claim/clm-declaration/clm-declaration.component';
import { ClmClaimComponent } from './components/claim/clm-claim/clm-claim.component';
import { ClmClaimerComponent } from './components/claim/clm-claimer/clm-claimer.component';
import { ClmGuidanceComponent } from './components/claim/clm-guidance/clm-guidance.component';

import { ClmWizardComponent } from './components/claim/clm-wizard/clm-wizard.component';
import { MatFormFieldModule, MatDatepickerModule, MatNativeDateModule, MatInputModule, MatIconModule } from '@angular/material';
import { GzzDatePickerComponent } from './components/general/gzz-date-picker/gzz-date-picker.component';
import { GzzChildComponent } from './components/general/gzz-child/gzz-child.component';
import { SurvivorsDeceasedComponent } from './components/survivors/survivors-deceased/survivors-deceased.component';
import { SurvivorsService } from './services/survivors/survivors.service';
import { GzzClosenessComponent } from './components/general/gzz-closeness/gzz-closeness.component';
import { GazzezetService } from './services/general/gazzezet.service';
import { ClaimService } from './services/claim/claim.service';

//import {MATERIAL_COMPATIBILITY_MODE} from '@angular/material';
@NgModule({
  declarations: [
    AppComponent,
    WorseningComponent,
    GzzMainContentComponent,
    WorseningClaimerComponent,
    WorseningAdvocateComponent,
    WorseningWorseDetailsComponent,
    SurvivorsComponent,
    SurvivorsWizardComponent,
    SurvivorsGuidanceComponent,
    SurvivorsClaimerComponent,
    GzzRepresenterComponent,
    SurvivorsClaimComponent,
    GzzBankAccountDetailsComponent,
    SurvivorsAdditionalInfoComponent,
    GzzFamilyMemberComponent,
    SurvivorsDeclarationComponent,
    ClaimComponent,
    ClmDeclarationComponent,
    ClmClaimComponent,
    ClmClaimerComponent,
    ClmWizardComponent,
    ClmGuidanceComponent,
    GzzDatePickerComponent,
    GzzChildComponent,
    SurvivorsDeceasedComponent,
    GzzClosenessComponent
  ],
  imports: [
    BrowserModule,
    FlexLayoutModule,
    HttpModule,
    HttpClientModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    FooterV2Module,
    HeaderV2Module,
    MainContentModule,
    ButtonV2Module,
    CheckboxV2Module,
    SectionTitleV2Module,
    TooltipV2Module,
    MohPackageModule.forRoot(),
    TextboxV2Module,
    TelephoneV2Module,
    LabelFieldModule,
    AddressV2Module,
    BreadcrumbsModule,
    DividerModule,
    FileUploaderV2Module,
    FormTitleV2Module,
    InfoV2Module,
    MohBaseElementModule,
    SlideToggleV2Module,
    BannerV2Module,
    TextareaV2Module,
    FormCardV2Module,
    SubmitButtonV2Module,
    ErrorMessageV2Module,
    SelectV2Module,
    SpinnerModule,
    //MohPackageModule.configure(environment),
    MohPackageModule.forRoot(),
    MohPackageModule.configure(environment.configJsonPath),
    MatDatepickerModule,
    MatFormFieldModule,
    MatNativeDateModule,
    MatInputModule,
    MatIconModule,
    RecaptchaModule
  ],
  providers: [{ provide: HTTP_INTERCEPTORS, useClass: MohHttpInterceptorService, multi: true },
    HttpClientModule, WorseningService, UtilitiesService, SurvivorsService, ClaimService, GazzezetService],
  // {provide: MATERIAL_COMPATIBILITY_MODE, useValue: true}
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// E:/Develop/MOH.Gazezet/Dev/MOH.Gazzezet/MOH.Gazzezet/src/app/app.module.ts